import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";
import { JobSharedDataService } from "../services/job-shared-service";
import { JobService } from "../services/job-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import { ContractService } from "../services/contract-service";
import { DocumentEntityService } from "../services/document-entity-service";
import { AdminService } from "../services/admin-service";
import { BaseEntityAssociationController } from "./rlAdmin.controllers";
import { EntityConfigService } from "../services/entity-config-service";
import { SearchService } from "../services/search-service";


export class JobSummaryController {

	static $inject = ["$scope", "$q", "$window", "jobService", "entityService", "notifyService", "jobSharedDataService", "eventService", "aclService"];

	jobID: string;                                                          // EntityID
	visibility: number;                                                     // visibility level of page
	sharedData: JobSharedDataService;
	locked: boolean;
	isValid: boolean;
	currencySymbol: string;
	charTypeName: string;
	listUrl: string;
	canEdit: boolean;
	selectedEntity: any;
	initialized: boolean;

	constructor(private $scope: ng.IScope,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private jobService: JobService,
		private entityService: EntityService,
		private notifyService: NotifyService,
		private jobSharedDataService: JobSharedDataService,
		private eventService: EventService,
		private aclService: AclService) {

		this.jobID = "";
		this.visibility = 1;
		this.sharedData = jobSharedDataService;
		this.locked = false;
		this.isValid = false;
		this.charTypeName = "";
		this.listUrl = "~/";
		this.canEdit = false;
		this.initialized = false;

		$scope.$watch(
			() => this.sharedData.jobStatus != null ? this.sharedData.jobStatus.lockIndicator : 1,
			(newvalue, oldvalue) => {
				this.locked = newvalue > 0;
			});

		$scope.$watch(
			() => {
				if (this.sharedData.job != null) {
					return this.sharedData.job.charDataCollection.charDatas[Consts.TagLabels.Currency];
				} else {
					return null;
				}
			},
			(newValue) => {
				if (newValue != null && newValue.length > 0) {
					this.currencySymbol = newValue[0].value;
				} else {
					this.currencySymbol = "";
				}
			}, true);

		this.$scope.$on(Consts.Events.ViewEntity, (e, data) => {
			if (!_.isEmpty(data)) {
				this.ViewEntity(data);
			}
		});
	}

	/*
	 * Initialize controller
	 * @param entityID entityID string of work order
	 */
	Init(entityID: string, charTypeName: string, listUrl: string) {
		this.jobID = entityID;
		this.sharedData.RefreshJobStatus(this.jobID)
			.then(() => {
				this.initialized = true;
			});
		if (!_.isEmpty(charTypeName)) {
			this.charTypeName = charTypeName;
		}
		if (!_.isEmpty(listUrl)) {
			this.listUrl = listUrl;
		}

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod15.Details);
			});
	}

	/*
	 * Refresh all sections of work order summary
	 */
	RefreshAll(): ng.IPromise<any[]> {
		// start progress bar
		this.notifyService.startProgress();

		return this.sharedData.RefreshJobStatus(this.jobID)
			.then(() => {
				var promises: ng.IPromise<any[]>[] = [];
				promises.push(this.RefreshValidation());
				//promises.push(this.eventService.call(Consts.Events.JobRefreshAll));
				return this.$q.all(promises)
					.finally(() => {
						this.notifyService.endProgress();
					});
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
			this.notifyService.startProgress();
			this.jobService.deleteJob(this.jobID)
				.then(() => {
					this.$window.location.assign(this.listUrl);
				},
				() => {
					this.notifyService.notifyError("Error Deleting " + this.charTypeName);
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	ViewEntity(viewEntityID: string) {
		this.entityService.getEntity(viewEntityID)
			.then((res) => {
				this.selectedEntity = res;
			});
	}
}

export class JobDetailsController {
	static $inject = ["$scope", "$window", "jobService", "entityService", "notifyService", "jobSharedDataService", "eventService", "aclService"];

	jobID: string;
	initialized: boolean;
	editMode: boolean;
	visibility: number;
	sharedData: JobSharedDataService;
	locked: boolean;
	isValid: boolean;
	charTypeName: string;
	listUrl: string;
	canEdit: boolean;

	constructor(private $scope: ng.IScope,
		private $window: ng.IWindowService,
		private jobService: JobService,
		private entityService: EntityService,
		private notifyService: NotifyService,
		private jobSharedDataService: JobSharedDataService,
		private eventService: EventService,
		private aclService: AclService) {

		this.jobID = "";
		this.initialized = false;
		this.editMode = false;
		this.visibility = 1;
		this.sharedData = jobSharedDataService;
		this.locked = false;
		this.isValid = false;
		this.charTypeName = "";
		this.listUrl = "~/";
		this.canEdit = false;

		$scope.$watch(
			() => this.sharedData.job != null ? this.sharedData.job.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			});

		$scope.$watch(
			() => this.sharedData.jobStatus != null ? this.sharedData.jobStatus.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			}, true);

		$scope.$watch(() => {
			if (this.jobID == null) {
				return null;
			} else {
				return this.jobID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.RefreshDetails();
					});
				}
			});
	}

	Init(jobID: string, charTypeName: string, listUrl: string) {
		this.jobID = jobID;
		this.RefreshDetails();
		this.RefreshInventory();
		this.sharedData.RefreshJobStatus(this.jobID);
		if (!_.isEmpty(charTypeName)) {
			this.charTypeName = charTypeName;
		}
		if (!_.isEmpty(listUrl)) {
			this.listUrl = listUrl;
		}
		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod15.Details);
			});

	}

	RefreshAll(): ng.IPromise<any> {
		return this.sharedData.RefreshJobStatus(this.jobID)
			.then(() => {
				return this.RefreshValidation();
			});
	}

	RefreshDetails(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.sharedData.RefreshJob(this.jobID)
			.then((result) => {
				this.initialized = true;
			}, () => {
				this.notifyService.notifyError("Job Not Found");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshInventory(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.sharedData.RefreshInventory(this.jobID)
			.then((result) => {
				this.initialized = true;
			}, () => {
				this.notifyService.notifyError("Job Not Found");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	Edit() {
		this.editMode = true;
	}

	Cancel() {
		this.notifyService.startProgress();
		this.entityService.getEntityCharData(this.sharedData.job.record.id)
			.then((result) => {
				this.sharedData.job.charDataCollection = result;
				this.editMode = false;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(isValid: boolean) {

		if (isValid) {
			this.notifyService.startProgress();
			this.entityService.saveCharData(this.sharedData.job.record.id, this.sharedData.job.charDataCollection.charDatas)
				.then(() => {
					this.notifyService.notifySuccess("Save Successful");
					return this.RefreshDetails();
				}, this.notifyService.errorResponseHandler)
				.then(() => {
					this.editMode = false;
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});

		}
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
			this.notifyService.startProgress();
			this.jobService.deleteJob(this.jobID)
				.then(() => {
					this.$window.location.assign(this.listUrl);
				},
				() => {
					this.notifyService.notifyError("Error Deleting " + this.charTypeName);
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}
}

export class JobInventoryController {
	static $inject = ["$scope", "$rootScope", "$q", "$window", "jobService", "notifyService", "entityService", "jobSharedDataService", "eventService", "aclService"];

	jobID: string;
	visibility: number;
	initialized: boolean;
	inventoryItems: Models.IEntityRelationshipPair[];
	selectedInventoryItems: Models.IEntityRelationshipPair[];
	sharedData: JobSharedDataService;
	locked: boolean;

	addInventoryModalOpen: boolean;
	inventoryTemplateGroupIDs: number[];

	selectedSearchInventoryIDs: number[];
	selectedSearchInventories: { [key: number]: boolean };                       // dictionary of selected Inventories from Inventory search modal
	groupCollapsed: { [groupID: string]: boolean };

	selectedParentCharTypeID: number;
	selectedCharTypeID: number;
	selectedParentTemplateID: number;
	showColumns: string[];
	canCreate: boolean;
	showAdvance: boolean;
	selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
	allowMultiple: boolean;
	selectedEntity: any;
	canEdit: boolean;
	previewEntityID: string;

	constructor(private $scope: ng.IScope,
		private $rootScope: ng.IRootScopeService,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private jobService: JobService,
		private notifyService: NotifyService,
		private entityService: EntityService,
		private jobSharedDataService: JobSharedDataService,
		private eventService: EventService,
		private aclService: AclService
	) {

		this.jobID = "";
		this.visibility = 1;
		this.initialized = false;
		this.inventoryItems = [];
		this.selectedInventoryItems = [];
		this.sharedData = jobSharedDataService;
		this.locked = false;
		this.addInventoryModalOpen = false;
		this.inventoryTemplateGroupIDs = [Consts.TemplateGroupIDs.InventoryItemTemplateGroup];
		this.selectedSearchInventoryIDs = [];
		this.selectedSearchInventories = {};
		this.groupCollapsed = {};
		this.showColumns = [];
		this.canCreate = false;
		this.showAdvance = true;
		this.selectedRecIdTitlePairs = [];
		this.allowMultiple = true;
		this.selectedCharTypeID = Consts.CharTypeIDs.inventory;
		this.selectedParentCharTypeID = Consts.CharTypeIDs.job;
		this.selectedParentTemplateID = 0;
		this.canEdit = false;

		$scope.$watch(() => this.selectedSearchInventories, (newValue: { [key: string]: boolean }) => {
			this.selectedSearchInventoryIDs = _(newValue)
				.pairs()
				.filter((pair) => pair[1] == true)
				.map((pair) => _.parseInt(<string>pair[0]))
				.valueOf();
		}, true);

		// clear selected assets whenever asset search modal is closed
		$scope.$watch(() => this.addInventoryModalOpen, (newValue: boolean, oldValue: boolean) => {
			if (!newValue && oldValue) {
				this.selectedSearchInventories = {};
			}
		}, true);

		$scope.$watch(
			() => this.sharedData.jobStatus != null ? this.sharedData.jobStatus.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			}, true);

		$scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
			this.previewEntityID = data;
		});
	}

	Init(jobID: string) {
		this.jobID = jobID;
		var splitEntity = Utils.IdBuilder.splitEntityID(this.jobID);
		var charTypeID = splitEntity.charTypeID;
		this.RefreshAll()
			.then(() => {
				this.initialized = true;
			});

		//Get ACLs for user
		this.entityService.getEntityRecord(this.jobID)
			.then((result) => {
				var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
				this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
			});
	}

	RefreshJob(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.sharedData.RefreshJob(this.jobID)
			.then((result) => {
				this.initialized = true;
				this.selectedParentTemplateID = result.record.templateID;
			}, () => {
				this.notifyService.notifyError("Job Not Found");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshAll(): ng.IPromise<any> {
		return this.$q.all([this.RefreshJob(), this.RefreshInventory(), this.RefreshJobStatus()])
			.then(() => {
				return this.RefreshValidation();
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	RefreshInventory(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.jobService.getJobInventory(this.jobID)
			.then((result) => {
				this.inventoryItems = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshJobStatus(): ng.IPromise<any> {
		return this.sharedData.RefreshJobStatus(this.jobID);
	}

	SearchInventory() {
		this.addInventoryModalOpen = true;
		this.notifyService.broadcastDone();
	}

	AddInventories() {
		var inventoryIDs: number[] = [];
		if (this.selectedRecIdTitlePairs.length > 0) {
			this.selectedRecIdTitlePairs.forEach((recIDTitlePair) => {
				if (!_.isUndefined(recIDTitlePair)) {
					inventoryIDs.push(recIDTitlePair.key);
				}
			});
		}

		if (inventoryIDs.length > 0) {
			// start progress bar
			this.notifyService.startProgress();

			// make rest call
			this.jobService.addJobInventory(this.jobID, inventoryIDs)
				.then((result) => {
					if (result.length > 0) {
						// notify success
						if (result.length == 1) {
							this.notifyService.notifySuccess("Added 1 inventory item.");
						} else {
							this.notifyService.notifySuccess("Added " + result.length + " inventory items.");
						}
						// wait for assets refresh
						return this.RefreshAll();
					}
				}, (event) => {
					// error handler
					this.notifyService.notifyError("There was an error associating these inventory items");
				})
				.then(() => {
					// close modal
					this.addInventoryModalOpen = false;
				})
				.finally(() => {
					// end progress bar
					this.notifyService.endProgress();
				});
		} else {
			// notify no selected assets
			this.notifyService.notifyError("No inventory items were selected");
		}
	}

	RemoveInventory(inventory: Models.IEntityRelationshipPair) {
		if (this.$window.confirm("Are you sure?")) {
			// start progress bar
			this.notifyService.startProgress();

			// call web api to remove assets
			this.jobService.removeJobInventory(this.jobID, inventory.relationship.relRecID)
				.then((result) => {
					// notify success
					this.notifyService.notifySuccess("Inventory Removed");
					// wait for refresh of assets
					return this.RefreshAll();
				})
				.finally(() => {
					// end progress bar
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Job?") && this.$window.confirm("Are you REALLY SURE you want to delete this Job?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.jobID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.JobListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Job");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	ToggleAddInventory() {
		this.addInventoryModalOpen = !this.addInventoryModalOpen;
	}

	ToggleOpen(groupID: string) {
		this.groupCollapsed[groupID] = !this.groupCollapsed[groupID];
	}

	ViewInventory(inventory: Models.IEntityRelationshipPair) {
		this.previewEntityID = inventory.record.id;
		this.$rootScope.$broadcast(Consts.Events.ViewEntity, inventory.record.id);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}
}

export class JobDocumentsController {
	static $inject = ["$scope", "$sce", "$q", "$window", "contractService",
		"documentEntityService", "notifyService", "jobSharedDataService", "eventService", "entityService",
		"adminService", "$interval", "aclService"];

	jobID: string;
	visibility: number;
	initialized: boolean;
	docsInitialized: boolean;
	locked: boolean;
	editDocumentID: string;
	canEdit: boolean;

	constructor(private $scope: ng.IScope,
		private $sce: ng.ISCEService,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		private contractService: ContractService,
		private documentEntityService: DocumentEntityService,
		private notifyService: NotifyService,
		private sharedData: JobSharedDataService,
		private eventService: EventService,
		private entityService: EntityService,
		private adminService: AdminService,
		private $interval: ng.IIntervalService,
		private aclService: AclService) {

		this.jobID = "";
		this.visibility = 1;
		this.initialized = false;
		this.docsInitialized = true;
		this.editDocumentID = null;
		this.locked = false;
		this.canEdit = false;

		$scope.$watch(
			() => this.sharedData.job != null ? this.sharedData.job.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			});

		$scope.$watch(() => {
			if (this.jobID == null) {
				return null;
			} else {
				return this.jobID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.sharedData.RefreshJob(this.jobID);
					});
				}
			});
	}

	Init(jobID: string) {
		this.jobID = jobID;
		this.notifyService.startProgress();
		this.sharedData.RefreshJob(this.jobID)
			.then(() => {
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod15.Details);
			});
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Job?") && this.$window.confirm("Are you REALLY SURE you want to delete this Job?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.jobID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.JobListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Job");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation()
			.then(() => {
				this.docsInitialized = false;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}
}

export class JobsEntityAssociationSearchController extends BaseEntityAssociationController {
	static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
		"eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "jobSharedDataService", "aclService"];

	//Search objects
	keywords: string;
	pages: { [key: number]: number };
	templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
	sortDirs: { [key: number]: string };
	sortFields: { [key: number]: string };
	selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	selectedTemplate: string;
	selectedStatus: string;
	searchStates: { [key: string]: Models.IAdvancedSearchModel };
	templateFacets: Models.IKeyValuePair<string, string>[];
	statusFacets: Models.IKeyValuePair<string, string>[];

	//Associations objects
	sharedData: JobSharedDataService;
	filterByEntityID: string;
	charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
	selectedRecords: any[];
	associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	locked: boolean;
	currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
	canCreate: boolean = false;
	canEdit: boolean = false;
	currentCharTypeName: string;
	refreshAssociationPanels: boolean;
	initialized: boolean;

	constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
		public notifyService: NotifyService, private $window: ng.IWindowService,
		public $q: ng.IQService,
		private eventService: EventService,
		private entityService: EntityService,
		private entityConfigService: EntityConfigService,
		public adminService: AdminService,
		public $interval: ng.IIntervalService,
		private searchService: SearchService,
		private jobSharedDataService: JobSharedDataService,
		private aclService: AclService) {

		super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

		//Search objects
		this.keywords = "";
		this.pages = {};
		this.templates = {};
		this.sortDirs = {};
		this.sortFields = {};
		this.selectedCharType = null;
		this.selectedTemplate = null;
		this.searchStates = {};
		this.templateFacets = [];
		this.statusFacets = [];

		//Associations objects
		this.sharedData = jobSharedDataService;
		this.filterByEntityID = "";
		this.charTypesAndTemplateGroups = [];
		this.selectedRecords = [];
		this.locked = false;
		this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
		this.currentCharTypeName = "";
		this.refreshAssociationPanels = false;
		this.initialized = false;

		$scope.$watch(() => this.sharedData.jobStatus != null ? this.sharedData.jobStatus.lockIndicator : 1,
			(newvalue, oldvalue) => {
				this.locked = newvalue > 0;
			});
	}

	CharTypeChanged() {
		this.selectedTemplate = null;
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	TemplateChanged() {
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	StatusChanged() {
		this.BuildSearchStates();
	}

	Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
		this.filterByEntityID = filterByEntityID;
		this.baseEntityID = filterByEntityID;
		this.currentCharTypeName = charTypeName;
		this.currentCharTypeAndTemplateGroup.charTypeID = Utils.IdBuilder.splitEntityID(this.filterByEntityID).charTypeID;
		this.currentCharTypeAndTemplateGroup.name = charTypeName;

		//Get ACLs for user
		this.entityService.getEntityRecord(filterByEntityID)
			.then((result) => {
				var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
				this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
				this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
			});

		this.LoadTemplateGroups();
		this.sharedData.RefreshJob(filterByEntityID);
		this.sharedData.RefreshJobStatus(filterByEntityID).then(() => {
			this.initialized = true;
		});
	}

	RefreshValidation(): ng.IPromise<any> {
		this.refreshAssociationPanels = true;
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	LoadTemplateGroups() {
		this.notifyService.startProgress();

		//Hardcoded list of valid char types per Joe N.
		//16, 1, 17, 4, 15, and 7
		var validCharTypes = [16, 1, 4, 17, 15, 7];

		this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.job)
			.then((results) => {

				_.forEach(results, (result) => {
					var charName = result.charTypeName;

					if (charName == "Transaction") {
						charName = "Deals";
					}
					else if (charName == "Work Orders") {
						charName = "Jobs";
					}
					else if (charName == "Property") {
						charName = "Catalog Items";
					}
					else if (charName == "Invoice") {
						charName = "Accounting";
					}

					if (validCharTypes.indexOf(result.charTypeID) > -1) {
						this.charTypesAndTemplateGroups.push({
							name: charName,
							createName: charName,
							charTypeID: result.charTypeID,
							tgIDs: [1],
							isParentChar: false
						});

						if (this.currentCharTypeName == charName) {
							this.currentCharTypeAndTemplateGroup = {
								name: charName,
								createName: charName,
								charTypeID: result.charTypeID,
								tgIDs: [],
								isParentChar: false
							}
						}
					}
				});
			})
			.finally(() => {
				this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.job)
					.then((results) => {
						_.forEach(results, (result) => {
							var charName = result.charTypeName;

							if (charName == "Transaction") {
								charName = "Deals";
							}
							else if (charName == "Work Orders") {
								charName = "Jobs";
							}
							else if (charName == "Property") {
								charName = "Catalog Items";
							}
							else if (charName == "Invoice") {
								charName = "Accounting";
							}

							var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

							//Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
							//If not, add the new charType

							var matchingCharTypes = this.charTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

							if (validCharTypes.indexOf(result.charTypeID) > -1) {
								if (matchingCharTypes.length > 0) {
									var index = this.charTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
									this.charTypesAndTemplateGroups[index].isParentChar = true;
								}
								else {
									this.charTypesAndTemplateGroups.push(charType);
								}

								if (this.currentCharTypeName == charName) {
									this.currentCharTypeAndTemplateGroup = {
										name: charName,
										createName: charName,
										charTypeID: result.charTypeID,
										tgIDs: [],
										isParentChar: true
									}
								}
							}
						});
					})
					.finally(() => {
						//Sort the list based on how Joe wants it
						//Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
						var sortList = [16, 1, 4, 17, 15, 7];

						var sorted = _.sortBy(this.charTypesAndTemplateGroups, function (obj) {
							return _.indexOf(sortList, obj.charTypeID);
						});

						var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

						this.SortByIndex(sorted, currentCharTypeIndex, 0);

						this.charTypesAndTemplateGroups = sorted;

						this.BuildSearchStates();
						this.notifyService.endProgress();
					});
			});
	}

	SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
		collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
	}

	SearchSubmit() {
		this.BuildSearchStates();
	}

	BuildSearchStates() {
		var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
		this.searchStates = {};

		var selectedCharTypeID = null;

		if (this.selectedCharType != null) {
			selectedCharTypeID = this.selectedCharType.charTypeID;
		}

		//associations
		var metaDataSearchRequest: Models.IAdvancedSearchModel = {
			charTypeID: selectedCharTypeID,
			searchGroups: [],
			keywords: this.keywords,
			page: this.pages[selectedCharTypeID] || 1,
			rowCount: 10,
			templateGroupIDs: [1, 2],
			template: this.selectedTemplate,
			status: this.selectedStatus,
			sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
			sortField: this.sortFields[selectedCharTypeID] || "",
			relatedEntityID: this.filterByEntityID
		};

		this.searchService.advancedSearch(metaDataSearchRequest)
			.then((res) => {
				this.templateFacets = res.getTemplateFacets();
				this.statusFacets = res.getStatusFacets();
			})
		// end reflective association search

		if (this.selectedCharType != null) {
			var searchState: Models.IAdvancedSearchModel = {
				charTypeID: selectedCharTypeID,
				searchGroups: [],
				keywords: this.keywords,
				page: this.pages[selectedCharTypeID] || 1,
				rowCount: 10,
				templateGroupIDs: [1, 2],
				template: this.selectedTemplate,
				status: this.selectedStatus,
				sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
				sortField: this.sortFields[selectedCharTypeID] || "",
				relatedEntityID: this.filterByEntityID,
				explicitRelationshipsOnly: true
			};

			tempSearchStates[this.selectedCharType.name] = searchState;
		}
		else {
			_.each(this.charTypesAndTemplateGroups, ct => {
				var searchState: Models.IAdvancedSearchModel = {
					charTypeID: ct.charTypeID,
					searchGroups: [],
					keywords: this.keywords,
					page: this.pages[selectedCharTypeID] || 1,
					rowCount: 10,
					templateGroupIDs: [1, 2],
					template: this.selectedTemplate,
					status: this.selectedStatus,
					sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
					sortField: this.sortFields[selectedCharTypeID] || "",
					relatedEntityID: this.filterByEntityID,
					explicitRelationshipsOnly: true
				};

				tempSearchStates[ct.name] = searchState;
			});
		}

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

		this.searchStates = tempSearchStates;
	}

	ClearSearch($event?: ng.IAngularEvent) {
		if ($event != null) {
			$event.preventDefault();
		}
		this.keywords = "";
		this.BuildSearchStates();
	}

	ViewEntity(viewEntityID: string) {
		this.entityService.getEntity(viewEntityID)
			.then((res) => {
				this.selectedEntity = res;
			});
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}
}
